/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreditCardMerchant } from './CreditCardMerchant';
import {
    CreditCardMerchantFromJSON,
    CreditCardMerchantFromJSONTyped,
    CreditCardMerchantToJSON,
    CreditCardMerchantToJSONTyped,
} from './CreditCardMerchant';
import type { CardOption } from './CardOption';
import {
    CardOptionFromJSON,
    CardOptionFromJSONTyped,
    CardOptionToJSON,
    CardOptionToJSONTyped,
} from './CardOption';

/**
 * Display information for a credit card payment option.
 * @export
 * @interface CreditCardDisplay
 */
export interface CreditCardDisplay {
    /**
     * 
     * @type {Array<CardOption>}
     * @memberof CreditCardDisplay
     */
    cardOptions?: Array<CardOption>;
    /**
     * 
     * @type {CreditCardMerchant}
     * @memberof CreditCardDisplay
     */
    merchant?: CreditCardMerchant;
    /**
     * Display name of payment option.
     * @type {string}
     * @memberof CreditCardDisplay
     */
    name?: string;
}

/**
 * Check if a given object implements the CreditCardDisplay interface.
 */
export function instanceOfCreditCardDisplay(value: object): value is CreditCardDisplay {
    return true;
}

export function CreditCardDisplayFromJSON(json: any): CreditCardDisplay {
    return CreditCardDisplayFromJSONTyped(json, false);
}

export function CreditCardDisplayFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditCardDisplay {
    if (json == null) {
        return json;
    }
    return {
        
        'cardOptions': json['card_options'] == null ? undefined : ((json['card_options'] as Array<any>).map(CardOptionFromJSON)),
        'merchant': json['merchant'] == null ? undefined : CreditCardMerchantFromJSON(json['merchant']),
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CreditCardDisplayToJSON(json: any): CreditCardDisplay {
    return CreditCardDisplayToJSONTyped(json, false);
}

export function CreditCardDisplayToJSONTyped(value?: CreditCardDisplay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'card_options': value['cardOptions'] == null ? undefined : ((value['cardOptions'] as Array<any>).map(CardOptionToJSON)),
        'merchant': CreditCardMerchantToJSON(value['merchant']),
        'name': value['name'],
    };
}

